module.exports = __webpack_public_path__ + "img/menu.1829025f.svg";